import React from "react";

export const templates = [
  {
    id: "app-feedback",
    name: "General App Feedback",
    icon: (props) => (
      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" {...props}>
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
      </svg>
    ),
    question: "What are your thoughts about the DingAI app?",
    placeholder: "Share your overall experience and feedback about using the DingAI app..."
  },
  {
    id: "app-issues",
    name: "App Issues & Problems",
    icon: (props) => (
      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" {...props}>
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
      </svg>
    ),
    question: "What issues or problems have you encountered while using DingAI?",
    placeholder: "Describe any bugs, errors, or difficulties you've experienced..."
  },
  {
    id: "app-improvements",
    name: "App Improvements & Suggestions",
    icon: (props) => (
      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" {...props}>
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
      </svg>
    ),
    question: "How can we improve the DingAI app to better serve your needs?",
    placeholder: "Share your suggestions for new features, improvements, or changes..."
  },
  {
    id: "app-features",
    name: "Feature Requests & Ideas",
    icon: (props) => (
      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" {...props}>
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
      </svg>
    ),
    question: "What new features or capabilities would you like to see in DingAI?",
    placeholder: "Tell us about features you'd like to see added to the app..."
  },
  {
    id: "custom",
    name: "Custom Question",
    icon: (props) => (
      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" {...props}>
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
      </svg>
    ),
    question: "Write your own question",
    placeholder: "Enter your custom question here..."
  }
];

const OpenEndedSurveyTemplates = ({ onSelectTemplate, selectedTemplateId }) => {
  const handleSelectTemplate = (template) => {
    onSelectTemplate(template);
  };

  return (
    <div className="rounded-lg border bg-white shadow-sm">
      <div className="flex flex-col space-y-1.5 p-6">
        <h3 className="font-medium text-gray-900">Start from a Template</h3>
        <p className="text-sm text-gray-500">
          Choose from proven templates designed to gather detailed feedback about the DingAI app
        </p>
        <div className="mt-2 flex items-center p-2 bg-blue-50 rounded-md border border-blue-100">
          <span className="mr-2 text-[#2962FF] font-bold">💡</span>
          <span className="text-sm text-gray-700">You can either start from a template or write your own question below.</span>
        </div>
      </div>
      <div className="p-6 pt-0 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {templates.map((template) => (
          <div 
            key={template.id} 
            className={`border rounded-lg transition-all cursor-pointer h-full flex flex-col ${
              selectedTemplateId === template.id 
                ? "ring-2 ring-[#2962FF] border-[#2962FF] shadow-md" 
                : "hover:border-[#2962FF]/40 hover:shadow"
            }`}
            onClick={() => handleSelectTemplate(template)}
          >
            <div className="p-4 pb-0">
              <div className="flex items-center gap-2">
                <div className="p-1.5 rounded-md bg-gray-100 text-gray-600">
                  <template.icon className="h-4 w-4" />
                </div>
                <h3 className="font-medium text-gray-900">{template.name}</h3>
              </div>
            </div>
            <div className="p-4 flex-grow">
              <p className="text-xs font-medium mb-2">{template.question}</p>
              <p className="text-xs text-gray-600 italic">
                {template.placeholder}
              </p>
            </div>
            <div className="p-4 pt-2 mt-auto">
              <button 
                type="button" 
                className={`w-full py-1 px-4 rounded text-sm border ${
                  selectedTemplateId === template.id
                    ? "bg-[#2962FF]/10 border-[#2962FF] text-[#2962FF]"
                    : "border-[#2962FF]/60 text-[#2962FF] hover:bg-[#2962FF]/5"
                }`}
                onClick={(e) => {
                  e.stopPropagation(); // Prevent triggering the card's onClick
                  handleSelectTemplate(template);
                }}
              >
                Use this template
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OpenEndedSurveyTemplates;
